import { Chip, styled, useTheme } from '@mui/material';
import { UserAvatar } from '../../../../components/UserAvatar/UserAvatar';
import { User } from '../../../../types';
import { Typography } from '../../../../components/Typography/Typography';
import { roleLabel } from '../../../../utils/roleLabels';
import { firstRole } from '../../../../utils/roles';

type Props = {
  user: User;
  /** Overrides the chip label (defaults to the user's first role), e.g. the role the modal acts on. */
  roleText?: string;
};
export function UserInfo({ user, roleText }: Props) {
  const { colors } = useTheme();

  return (
    <Container>
      <AvatarWrap>
        <UserAvatar
          style={{
            width: 28,
            height: 28,
          }}
          name={user?.name}
          size='large'
          lettersStyle={{
            color: colors.textAccent.inverse,
            fontSize: 14,
          }}
        />
        {user.name}
      </AvatarWrap>
      <Chip
        style={{
          backgroundColor: colors.surfaceStatus.noAction,
          minWidth: '66px',
          height: '30px',
        }}
        label={
          <Typography variant='body' color={colors.text.main}>
            {roleText ?? roleLabel(firstRole(user))}
          </Typography>
        }
      />
    </Container>
  );
}

export default UserInfo;

const Container = styled('div')`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const AvatarWrap = styled('div')`
  display: flex;
  gap: 10px;
  align-items: center;
`;
